import VueRouter, { RouteConfig } from "vue-router";
import AppHeader from "@/components/AppHeader/index.vue";
import AppFooter from "@/components/AppFooter/index.vue";
import AsbestosSitePage from "@/pages/subPages/AsbestosSitePage/index.vue";
import AddEquipmentPage from "@/pages/subPages/AddEquipmentPage/index.vue";
import MainView from "@/pages/MainView.vue";
const routes: Array<RouteConfig> = [
  {
    path: "/",
    components: {
      default: MainView,
      header: AppHeader,
      footer: AppFooter,
    },
    children: [
      {
        path: "/",
        component: AsbestosSitePage,
      },
      {
        path: "/suppliersInformations",
        component: AddEquipmentPage,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

export default router;
